(function() { window.GUID_629964c2_b10d_4ebe_842d_7c4af837edc6 = { getGuid: function() { return "629964c2-b10d-4ebe-842d-7c4af837edc6"; } }; })();
var CompuSport;
(function (CompuSport) {
    let Layout;
    (function (Layout) {
        class Size {
            constructor(width, height) {
                this.Width = width;
                this.Height = height;
            }
        }
        Layout.Size = Size;
        class Position {
            constructor(left, top) {
                this.Left = left;
                this.Top = top;
                this.Right = 0;
                this.Bottom = 0;
            }
        }
        Layout.Position = Position;
        const layoutHelperLeft = "LayoutHelperLeft";
        const layoutHelperRight = "LayoutHelperRight";
        const layoutHelperTop = "LayoutHelperTop";
        const layoutHelperBottom = "LayoutHelperBottom";
        function CalculateDistance(x1, y1, x2, y2) {
            return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
        }
        Layout.CalculateDistance = CalculateDistance;
        function CalculateDistanceOfPoint(point1, point2) {
            return Math.sqrt((point1.Left - point2.Left) * (point1.Left - point2.Left) + (point1.Top - point2.Top) * (point1.Top - point2.Top));
        }
        Layout.CalculateDistanceOfPoint = CalculateDistanceOfPoint;
        function AllLayoutHelperClasses() {
            return layoutHelperLeft + ' ' + layoutHelperLeft + ' ' + layoutHelperLeft + ' ' + layoutHelperLeft;
        }
        Layout.AllLayoutHelperClasses = AllLayoutHelperClasses;
        function PositionTargetRefToSourceAndWindows(elementReference, elementToPosition) {
            //Permet de faire en sorte que le height est calculé en fonction du contenu et non en fonction de sa position absolute
            //Sinon, le fait d'avoir un bottom ou top a 0 affecte le height, donc, si la liste est plus petite
            //que la taille engendré par le bottom ou top a zero, ben le height ne se rajusterait pas. 
            //En mettant a auto, le calcul sera toujours basé sur le contenu.
            elementToPosition.css({
                top: 'auto', bottom: 'auto'
            });
            let refIsInBody = elementReference.parent().is('body');
            var forcedOnTop = false;
            var forcedOnBottom = false;
            if (elementReference.hasClass('ForcedOnTop')) {
                forcedOnTop = true;
            }
            else if (elementReference.hasClass('ForcedOnBottom')) {
                forcedOnBottom = true;
            }
            var offsetHoriBody = CompuSport.DOM.body.offset().left;
            var offsetVertBody = CompuSport.DOM.body.offset().top;
            var offset = elementReference.offset();
            var sourceWidth = elementReference[0].offsetWidth;
            var sourceHeight = elementReference[0].offsetHeight;
            var scrollWindowTop = CompuSport.DOM.win.scrollTop();
            var width = CompuSport.DOM.win.width();
            var height = CompuSport.DOM.win.height();
            var middleH = width / 2;
            var middleV = height / 2 + scrollWindowTop;
            var sourceMiddleH = sourceWidth / 2 + offset.left;
            var sourceMiddleV = sourceHeight / 2 + offset.top;
            var cssMenu = null;
            var top = null;
            var left = null;
            var right = null;
            var bottom = null;
            //fix offset dans chrome android zoomed
            var curleft = 0;
            var curtop = 0;
            var obj = elementReference[0];
            if (obj.offsetParent) {
                do {
                    curleft += obj.offsetLeft + jQuery.css(obj, "borderLeftWidth", true);
                    curtop += obj.offsetTop + jQuery.css(obj, "borderTopWidth", true);
                    obj = obj.offsetParent;
                } while (obj);
            }
            if (offset.top - curtop > 15) {
                offset.left -= CompuSport.DOM.win.scrollLeft();
                offset.top -= CompuSport.DOM.win.scrollTop();
            }
            var customClass = '';
            let rightPos = (width - offset.left - offsetHoriBody) - sourceWidth;
            let leftPos = (offset.left - offsetHoriBody);
            if (refIsInBody) {
                leftPos += offsetHoriBody;
            }
            if (rightPos < 0) {
                rightPos = 0;
            }
            if (leftPos < 0) {
                leftPos = 0;
            }
            if (sourceMiddleH > middleH) {
                left = 'auto';
                right = rightPos + 'px';
                customClass = layoutHelperRight;
            }
            else {
                left = leftPos + 'px';
                right = 'auto';
                customClass = layoutHelperLeft;
            }
            let bottomPos = (height - offset.top + scrollWindowTop - offsetVertBody);
            let topPos = offset.top - scrollWindowTop + sourceHeight - offsetVertBody;
            if (refIsInBody) {
                topPos += offsetVertBody;
            }
            if (bottomPos < 0) {
                bottomPos = 0;
            }
            if (topPos < 0) {
                topPos = 0;
            }
            if ((sourceMiddleV > middleV || forcedOnTop) && !forcedOnBottom) {
                top = 'auto';
                bottom = bottomPos + 'px';
                customClass += ' ' + layoutHelperBottom;
            }
            else {
                top = topPos + 'px';
                bottom = 'auto';
                customClass += ' ' + layoutHelperTop;
            }
            var outerHeight = elementToPosition.outerHeight(true);
            if (top == "auto") {
                if (bottomPos + outerHeight > height * 0.95) {
                    top = 0;
                }
            }
            else if (bottom == "auto") {
                if (topPos + outerHeight + sourceHeight + offsetVertBody >= height * 0.95) {
                    bottom = 0;
                }
            }
            elementToPosition.css({
                left: left, right: right, top: top, bottom: bottom
            });
            return customClass;
        }
        Layout.PositionTargetRefToSourceAndWindows = PositionTargetRefToSourceAndWindows;
        function AutoSizeWithParentContainer(element) {
            if (element == null || element.length == 0) {
                return;
            }
            element.css('height', 'auto');
            element.css('width', 'auto');
            var parent = element.parent();
            var elementWidth = element.width();
            var elementHeight = element.height();
            var parentWidth = parent.width();
            var parentHeight = parent.height();
            var parentRatio = parentWidth / parentHeight;
            var ratioX = parentWidth / elementWidth;
            var ratioY = parentHeight / elementHeight;
            if (ratioX > ratioY) {
                element.css('height', '100%');
                let newWidth = (elementWidth * parentHeight / elementHeight);
                let newLeft = (parentWidth - newWidth) / 2;
                element.css({
                    'position': 'absolute',
                    'height': '100%',
                    'width': newWidth + "px",
                    'top': 'auto',
                    'left': newLeft + "px"
                });
            }
            else {
                let newHeight = (elementHeight * parentWidth / elementWidth);
                let newTop = (parentHeight - newHeight) / 2;
                element.css({
                    'position': 'absolute',
                    'height': newHeight + "px",
                    'width': "100%",
                    'left': 'auto',
                    'top': newTop + "px"
                });
            }
        }
        Layout.AutoSizeWithParentContainer = AutoSizeWithParentContainer;
    })(Layout = CompuSport.Layout || (CompuSport.Layout = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Layout.js.map
